import React from "react";
import TeamSection from "../Component/TeamSection"; // ✅ correct capitalization

const TeamPage = () => {
  return (
    <div>
      <TeamSection />
    </div>
  );
};

export default TeamPage;
